let promptHandler = null;

export function registerAdminStepUpHandler(handler) {
  promptHandler = handler;
  return () => {
    if (promptHandler === handler) promptHandler = null;
  };
}

export function requestAdminStepUp(challenge) {
  if (!promptHandler) {
    const error = new Error('Admin confirmation is unavailable');
    error.code = 'ADMIN_STEP_UP_UNAVAILABLE';
    return Promise.reject(error);
  }
  const priorFocus = typeof document !== 'undefined' ? document.activeElement : null;
  return promptHandler({ ...challenge, priorFocus });
}
